import axios from "axios";
import determineApplicationStatus from "./utils";

import { identify, addUserProperty, addEventProperty, identifyHotjarUser, initializeHotjar } from "../../api/heap";


const types = {
  UPDATE_USER: "UPDATE_USER",
  UPDATE_DATABASE: "UPDATE_DATABASE",
  VERIFICATION_EMAIL_SEND_ERROR: "VERIFICATION_EMAIL_SEND_ERROR",
  VERIFICATION_EMAIL_VALID: "VERIFICATION_EMAIL_VALID", // FIREBASE LISTENER
  VERIFICATION_SMS_SEND: "VERIFICATION_SMS_SEND",
  VERIFICATION_SMS_SEND_ERROR: "VERIFICATION_SMS_SEND_ERROR",
  VERIFICATION_SMS_CHECK: "VERIFICATION_SMS_CHECK",
  VERIFICATION_SMS_CHECK_ERROR: "VERIFICATION_SMS_CHECK_ERROR",
  VERIFICATION_SMS_SENT: "VERIFICATION_SMS_SENT",
  VERIFICATION_SMS_VALID: "VERIFICATION_SMS_VALID",
  VERIFICATION_SMS_INVALID: "VERIFICATION_SMS_INVALID",
  VERIFICATION_SMS_RESET: "VERIFICATION_SMS_RESET",
  ADDRESS_VALID: "ADDRESS_VALID",
  ADDRESS_INVALID: "ADDRESS_INVALID",
  SSN_VALID: "SSN_VALID",
  SSN_INVALID: "SSN_INVALID",
  ID_VALID: "ID_VALID",
  SET_ID_NEEDS_REVIEW: "SET_ID_NEEDS_REVIEW",
  SET_IDENTITY_VERIFIED: "SET_IDENTITY_VERIFIED",
  UPDATE_STEP: "UPDATE_STEP",
  SET_FINGERPRINT: "SET_FINGERPRINT",
  SET_REFRESH_TOKEN: "SET_REFRESH_TOKEN",
  SET_PLAID_LINK_TOKEN: "SET_PLAID_LINK_TOKEN",
  SET_PLAID_ACCESS_TOKEN: "SET_PLAID_ACCESS_TOKEN",
  UPDATE_USER_INCOME: "UPDATE_USER_INCOME",
  UPDATE_USER_BALANCE: "UPDATE_USER_BALANCE",
  GOVT_ID_UPLOADED: "GOVT_ID_UPLOADED",
  SET_ID_FRONT: "SET_ID_FRONT",
  SET_ID_BACK: "SET_ID_BACK",
  SET_NETWORKING_ERROR: "SET_NETWORKING_ERROR",
  SET_PHONE_NUMBER_VERIFIED: "SET_PHONE_NUMBER_VERIFIED",
  SET_APPLICATION_PROGRESS: "SET_APPLICATION_PROGRESS",
  SET_APPLICATION_ID: "SET_APPLICATION_ID",
  UPDATE_VERIFICATION_PROGRESS: "UPDATE_VERIFICATION_PROGRESS",
  SHOW_ID_TIPS: "SHOW_ID_TIPS",
  SET_LOGINS_REQUIRED: "SET_LOGINS_REQUIRED",
  SET_FINICITY_LOGINS_REQUIRED: "SET_FINICITY_LOGINS_REQUIRED",
  SET_AGGREGATOR_TYPE: "SET_AGGREGATOR_TYPE"
};

const stepIndices = {
  basicInfo: 0,
  verifyPhone: 1,
  address: 2,
  personalInformation: 3,
  verifyId: 4,
  linkBank: 5,
  student: 6,
  confirm: 7,
  verifyIdDocs: 8
};

//  -----[ USER ]----- //
export const updateUser = payload => ({
  type: types.UPDATE_USER,
  payload
});

/**
 * Action that calls the presubmissionCheck api, to determine if the user is likely to be rejected.
 * @returns {object} response Axios response object 
 */
export const presubmissionCheck = () => async () => {
  try {
    const response = await axios.get('/presubmissionCheck')
    return response;
    // Note @{lbarrick}: Even if the server errors/timeouts we want the user to move forward.
    // We should change this in the future.
  } catch (e) {
    return {
      data: {
        ok: true,
        linked: true
      }
    }
  }

  
}

/**
 * Method used to determine if the user had a possible miskey for SSN or DOB
 * @param {string} userId primary key used to identify the user for Sentilink 
 */
export const identityCheck = () => async () => {

  try {
    //TODO @{lbarrick}: this should be changed to a GET
    const response = await axios.get('/identityCheck')
    return response;

    // Note @{lbarrick}: Even if the server errors/timeouts we want the user to move forward.
    // We should change this in the future.
  } catch (e) {
    return {
      data: {
        potentialMiskey: false
      }
    }
  }
}


export const getDecision = () => (dispatch, getState) => {
  const {
    register: {
      user: { email, ssn }
    }
  } = getState();

  const payload = {
    userId: email,
    ...(ssn && { num: ssn })
  };
  axios
    .post("/api/v2/getDecision", payload)
    .then(response => {
      const { data } = response;
      // {@rahmteen - shouldShowHome redirect to mock dash}
      // {@note tbd: if (!data.user.meetsBalanceThreshold || data.shouldShowHome)}
      if (data.shouldShowHome) {
        let shouldShowHome = data.shouldShowHome;
        dispatch(updateUser({ shouldShowHome }));
        window.onbeforeunload = null;
        if (window.location.pathname !== "/register/home") {
          return window.location = "/register/home";
        }
        return;
      }
      if (
        data.approved === false &&
        !data.idInvalid &&
        !data.unlinkedAccounts
      ) {
        window.localStorage.removeItem("jwt");
      }
      if (data.pending) {
        const {
          approved,
          pending,
          idInvalid,
          unlinkedAccounts, // TODO: make sure backend is sending this for finicity
          entityToken,
          hints
        } = data;
        if (unlinkedAccounts === true) {
          console.log(
            "Unlinked accounts found during decision. Directing user to re-link!"
          );
          window.onbeforeunload = null;
          window.location = "/register/linkbank";
        }
        dispatch(
          updateStep("decision", {
            approved,
            pending,
            idInvalid,
            unlinkedAccounts,
            hints,
            stepIsComplete: true
          })
        );
        //TODO @{lbarrick}: Should combine these two into a singular call.
        addUserProperty({ application_status: determineApplicationStatus(data)})
        addEventProperty({ ApplicationStatusEvent: determineApplicationStatus(data)})

        dispatch(
          updateStep("processingApplication", {
            stepIsComplete: true
          })
        );
        dispatch(
          updateUser({
            entityToken
          })
        );
      } else if (data.error_code || data.error_message) {
        const { error_message } = data;
        dispatch(
          updateStep("decision", {
            error: error_message || data.error.en
          })
        );
        dispatch(
          updateStep("processingApplication", {
            error: error_message || data.error.en
          })
        );
        //TODO @{lbarrick}: Should combine these two into a singular call.
        addUserProperty({ application_status: determineApplicationStatus(data)})
        addEventProperty({ ApplicationStatusEvent: determineApplicationStatus(data)})
      } else {
        const { approved, amount, reason, jwt } = data;
        if (jwt) {
          window.localStorage.setItem("jwt", jwt);
        }

        dispatch(
          updateStep("decision", {
            approved,
            amount,
            reason,
            stepIsComplete: true
          })
        );
        
        //TODO @{lbarrick}: Should combine these two into a singular call.
        addUserProperty({ application_status: determineApplicationStatus(data)})
        addEventProperty({ ApplicationStatusEvent: determineApplicationStatus(data)})
        
        dispatch(
          updateStep("processingApplication", {
            stepIsComplete: true
          })
        );
        
      }
    })
    .catch(error => {
      console.log("Error getting decision: ", error);
      dispatch(
        updateStep("decision", {
          approved: false,
          pending: true,
          stepIsComplete: true
        })
      );

      dispatch(
        updateStep("processingApplication", {
          stepIsComplete: true
        })
      );
      //TODO @{lbarrick}: Should combine these two into a singular call.
      addUserProperty({ application_status: 'pending'})
      addEventProperty({ ApplicationStatusEvent: 'pending'})
      // dispatch(
      //   updateStep("decision", {
      //     approved: false,
      //     reason: "Error getting a decision"
      //   })
      // );
      // dispatch(
      //   updateStep("processingApplication", {
      //     error: error.message
      //   })
      // );
    });
};

// -----[ DATABASE ]----- //
// TODO: Move these to own file
export const updateUserDatabase = (
  userId,
  payload,
  returning,
) => async dispatch => {
  // NOTE: We must first CREATE a user in order to update it. Maybe update updateUser API
  return axios
    .post("/updateUser", {
      userId: userId,
      payload
    })
    .then(response => {
      console.log("Updated database successfully");
      
      const { error } = (response || {}).data || {};
      if (returning) return { success: !!(response && !error) };
      
    })
    .catch(error => {
      console.log("Failed to update database: ", error);
      if (returning) return { success: false };
      dispatch(setNetworkingError('There was a networking error, please try again.'));
    });
};

export const newUserSignup = (userId, payload) => async dispatch => {
  const success = await axios
    .post("/newUserSignup_v2", {
      userId: userId,
      payload
    })
    .then(async response => {
      const { data: { token } = {} } = response;
      if (response.data && token) {
        console.log("New user signup - success");
        window.localStorage.setItem("jwt", token);
        
        // reset error handling variables upon new user signups
        dispatch(setNetworkingError(null));  
        return true;
      }
      
      return false;
    })
    .catch(error => {
      console.log("Failed to sign up new user: ", error);
      dispatch(setNetworkingError('There was an error creating your account, please try again.'));
      return false;
    });

  return success;
};

// -----[ PLAID ]----- //
// TODO: Move these to own file
export const setPlaidAccessToken = plaidAccessToken => ({
  type: types.SET_PLAID_ACCESS_TOKEN,
  plaidAccessToken
});

export const setPlaidLinkToken = plaidLinkToken => ({
  type: types.SET_PLAID_LINK_TOKEN,
  plaidLinkToken
});

export const fetchPlaidToken = (payloadParams) => async dispatch => {
  if(!payloadParams)
    return { error: "fetchPlaidToken: parameter passed in was a falsy value " };
  
  dispatch(setNetworkingError(null));
  const { fetchFromDb } = payloadParams;
  
  const existingLinkToken = localStorage.getItem("plaid_link_token");
  if(existingLinkToken){
    console.log(`Plaid token exists from localStorage: ${existingLinkToken}`);
    dispatch(setPlaidLinkToken(existingLinkToken));
    return { fromOauthRedirect: true, linkToken: existingLinkToken };
  }

  let results;
  try {
    results = await axios.post("/api/v2/accounts/getAndUpdatePlaidLinkToken", payloadParams);  
  } catch (error) {
    console.log("Error in fetchPlaidToken:", error);
    dispatch(setNetworkingError("Something went wrong - please try again"));
    return { error };
  }

  if(!results.data){
    dispatch(setNetworkingError("Something went wrong - please try again"));
    return { error: "Error in fetchPlaidToken: No data received from getAndUpdatePlaidLinkToken" };
  }
  
  const { link_token } = results.data;

  localStorage.setItem("plaid_link_token", link_token);
  dispatch(setPlaidLinkToken(link_token));
  return { fromOauthRedirect: fetchFromDb, linkToken: link_token };
};

export const removePlaidToken = (params) => async dispatch => {
  if(!params)
    throw new Error(`Error in removePlaidToken: Invalid paramters passed`);
  
  const { removeFromDb, plaidLinkToken } = params || {};
  console.log("Attempting to remove plaidToken");
  localStorage.removeItem("plaid_link_token");
  dispatch(setPlaidLinkToken(null));

  if(!removeFromDb)
    return;
  
  try {
    await axios.post("/api/v2/accounts/removeLinkToken", { link_token: plaidLinkToken });
  } catch (error) {
    console.log(`Error in removing plaid token from DB: `, error);
  }
};

// TODO: Clean up the API behind this, it's kinda nasty
// Right now this call will not only get the access token, but also
// get 30 days of transactions and update Firebase with it
export const linkAccounts = sentData => async (dispatch, getState) => {
  const options = {
    returnAccessToken: true,
    returnInstitutionData: true, // This gets us a logo, and info on the institution
    includeTopLevelAccounts: true,
    includeTopLevelAccessToken: false,
    includeTopLevelErrors: true,
    includeTopLevelWarnings: true,
    // returnFullIdentityDetails: true,
    estimateLimit: true
  };

  console.log("sent data", sentData);

  try {
    const {
      data: {
        accounts = [],
        unsupportedAccounts = [],
        accountsLinked,
        institution = {},
        estimatedLimit,
        meetsBalanceThreshold,
        hasDuplicatedAccounts,
      }
    } = await axios.post("/api/v2/accounts/addPlaidAccounts", {
      ...sentData,
      options
    });

    dispatch(
      updateStep("linkBank", {
        loading: false
      })
    );

    console.log("accounts", accounts, accountsLinked);

    // if (response.data.error) {
    //   dispatch(
    //     setNetworkingError(response.data.error || "Error linking account(s)")
    //   );
    //   return;
    // }
    dispatch(setNetworkingError(null));
    dispatch(updateStep("linkBank", { error: null }));

    const {
      register: {
        linkBank,
        user: { email }
      }
    } = getState();

    const depositoryAccountLinked = !!accounts.find(a =>
      ["checking", "savings"].includes(a.subtype)
    );

    console.log("accounts");
    console.log("depositoryAccountLinked -", depositoryAccountLinked);

    if ((unsupportedAccounts || []).length) {
      console.log(
        "There were unsupportedAccounts returned.",
        `There ${
          accountsLinked ? "were" : `were not`
        } (${accountsLinked}) accounts linked. Displaying modal only if no accounts were linked.`
      );
      dispatch(
        updateStep("linkBank", {
          ...(!accountsLinked && { showUnsupportedAccountsModal: true }),
          unsupportedAccounts
        })
      );
    }

    if (accountsLinked && accountsLinked > 0) {
      if (depositoryAccountLinked) {
        dispatch(updateStep("linkBank", { stepIsComplete: true, error: null }));
        dispatch(
          updateUserDatabase(email, {
            applicationProgress: {
              ...(!linkBank.stepIsComplete && {lastCompletedStep: stepIndices.linkBank}),
              linkBank: true,
              lastUpdated: new Date()
            }
          })
        );
      }
      // else {
      //   dispatch(
      //     updateStep("linkBank", {
      //       error:
      //         "You must link a checking and/or savings account to continue",
      //     })
      //   );
      // }
    }

    let existingAccounts = linkBank.linkedAccounts;
    // Add accounts to existingAccounts
    if (existingAccounts) {
      console.log("2b: got accounts:", accounts);
      console.log("2b: We have existing accounts: ", existingAccounts);
      let existingInstitutions = Object.keys(existingAccounts);
      console.log("2b: We have existing institutions: ", existingInstitutions);

      if (existingInstitutions.includes((institution || {}).name)) {
        console.log(
          "2b: Our existing institutions includes our new institution -",
          institution.name
        );
        existingAccounts[institution.name] = [
          ...(existingAccounts[institution.name] || []),
          ...(accounts || [])
        ];
        console.log(
          "2b: Made existing accounts[institution.name] equal to existingAccounts[institution.name] + ...accounts",
          accounts
        );
        console.log("2b: existing accounts is now", existingAccounts);
        dispatch(
          updateStep("linkBank", {
            linkedAccounts: {
              ...existingAccounts
              // [institution.name]: [...accounts]
            },
            loading: false
          })
        );
      } else {
        console.log(
          "institution",
          institution.name,
          "not in",
          existingInstitutions,
          "- adding"
        );
        // Avoid adding 'undefined' to linked accounts
        if (institution.name) {
          dispatch(
            updateStep("linkBank", {
              linkedAccounts: {
                ...(linkBank.linkedAccounts || {}),
                [institution.name]: [...(accounts || [])]
              },
              loading: false
            })
          );
        }
      }
    } else {
      dispatch(
        updateStep("linkBank", {
          linkedAccounts: { [institution.name]: [...(accounts || [])] }
        })
      );
    }
    if (linkBank.institutions) {
      dispatch(
        updateStep("linkBank", {
          institutions: [...(linkBank.institutions || []), institution]
        })
      );
    } else {
      dispatch(
        updateStep("linkBank", {
          institutions: [institution]
        })
      );
    }
    if (estimatedLimit !== undefined) {
      dispatch(updateUser({ estimatedLimit }));
    }
    // {@rahmteen - updated after linking accounts}
    dispatch(updateUser({ meetsBalanceThreshold }))

    if(hasDuplicatedAccounts) {
      dispatch(
        updateStep("linkBank", {
          error:
            "You have added the same bank account twice, we have removed one of those duplicate banks.",
        })
      );
    }
    console.log("accounts", accounts);
  } catch (err) {
    console.log("linkAccount encountered an error:", err);
    dispatch(
      updateStep("linkBank", {
        loading: false
      })
    );
    dispatch(
      setNetworkingError(
        "Your bank is taking longer than expected to respond. Please refresh the page and try again."
      )
    );
  }

  // axios
  //   .post("/user/accounts/link", { ...sentData, options })
  //   .then((response) => {
  //     dispatch(
  //       updateStep("linkBank", {
  //         loading: false,
  //       })
  //     );

  //     if (response.data.error) {
  //       dispatch(
  //         setNetworkingError(response.data.error || "Error linking account(s)")
  //       );
  //       return;
  //     }
  //     dispatch(setNetworkingError(null));
  //     updateStep("linkBank", { error: null });

  //     const {
  //       success,
  //       errors: {
  //         paymentMethods = {},
  //         investmentAccounts = {},
  //         otherAccounts = {},
  //       } = {},
  //       paymentMethods: allPaymentMethods = {},
  //       investmentAccounts: allInvestmentAccounts = {},
  //       otherAccounts: allOtherAccounts = {},
  //       unsupportedAccounts = [],
  //       accounts = [],
  //       institution = {},
  //       estimatedLimit,
  //       accountsLinked,
  //     } = response.data;

  //     const {
  //       register: {
  //         linkBank,
  //         user: { email },
  //       },
  //     } = getState();

  //     console.log('link bank', linkBank);

  //     const depositoryAccountLinked = !!accounts.find((a) =>
  //       ["checking", "savings"].includes(a.type)
  //     );
  //     console.log("depositoryAccountLinked -", depositoryAccountLinked);

  //     if (accountsLinked && accountsLinked > 0) {
  //       if (depositoryAccountLinked) {
  //         dispatch(updateStep("linkBank", { stepIsComplete: true }));
  //         dispatch(
  //           updateUserDatabase(email, {
  //             applicationProgress: {
  //               lastCompletedStep: stepIndices.linkBank,
  //               linkBank: true,
  //               lastUpdated: new Date(),
  //             },
  //           })
  //         );
  //       } else {
  //         dispatch(
  //           updateStep("linkBank", {
  //             error:
  //               "You must link a checking and/or savings account to continue",
  //           })
  //         );
  //       }
  //     }

  //     if ((unsupportedAccounts || []).length) {
  //       dispatch(updateStep("linkBank", { unsupportedAccounts }));
  //     }

  //     if (
  //       (paymentMethods.errors || []).length ||
  //       (investmentAccounts.errors || []).length ||
  //       (otherAccounts.errors || []).length
  //     ) {
  //       const paymentErrors = [...(paymentMethods.errors || [])];
  //       const investmentErrors = [...(investmentAccounts.errors || [])];
  //       const otherErrors = [...(otherAccounts.errors || [])];
  //       const {
  //         register: {
  //           linkBank: { accountErrors: existingErrors },
  //         },
  //       } = getState();
  //       const allErrors = [
  //         ...paymentErrors,
  //         ...investmentErrors,
  //         ...otherErrors,
  //         ...existingErrors,
  //       ];
  //       dispatch(updateStep("linkBank", { accountErrors: allErrors }));
  //     }

  //     if (
  //       (allPaymentMethods.warnings || []).length ||
  //       (allInvestmentAccounts.warnings || []).length ||
  //       (allOtherAccounts.warnings || []).length
  //     ) {
  //       const paymentWarnings = [...(allPaymentMethods.warnings || [])];
  //       const investmentWarnings = [...(allInvestmentAccounts.warnings || [])];
  //       const otherWarnings = [...(allOtherAccounts.warnings || [])];
  //       const {
  //         register: {
  //           linkBank: { accountWarnings: existingWarnings },
  //         },
  //       } = getState();
  //       const allWarnings = [
  //         ...(paymentWarnings || []),
  //         ...(investmentWarnings || []),
  //         ...(otherWarnings || []),
  //         ...(existingWarnings || []),
  //       ];
  //       dispatch(updateStep("linkBank", { accountWarnings: allWarnings }));
  //     }

  //     // dispatch(setPlaidAccessToken(access_token)); // No longer needed!
  //     // This condition serves no purpose...
  //     // TODO: This is ugly and should probably be handled in the reducer

  //     // let existingAccounts = linkBank.linkedAccounts;

  //     // if (existingAccounts) {
  //     //   console.log("2b: got accounts:", accounts);
  //     //   console.log("2b: We have existing accounts: ", existingAccounts);
  //     //   let existingInstitutions = Object.keys(existingAccounts);
  //     //   console.log(
  //     //     "2b: We have existing institutions: ",
  //     //     existingInstitutions
  //     //   );

  //     //   if (existingInstitutions.includes(institution.name)) {
  //     //     console.log(
  //     //       "2b: Our existing institutions includes our new institution -",
  //     //       institution.name
  //     //     );
  //     //     existingAccounts[institution.name] = [
  //     //       ...(existingAccounts[institution.name] || []),
  //     //       ...(accounts || []),
  //     //     ];
  //     //     console.log(
  //     //       "2b: Made existing accounts[institution.name] equal to existingAccounts[institution.name] + ...accounts",
  //     //       accounts
  //     //     );
  //     //     console.log("2b: existing accounts is now", existingAccounts);
  //     //     dispatch(
  //     //       updateStep("linkBank", {
  //     //         linkedAccounts: {
  //     //           ...existingAccounts,
  //     //           // [institution.name]: [...accounts]
  //     //         },
  //     //         loading: false,
  //     //       })
  //     //     );
  //     //   } else {
  //     //     console.log(
  //     //       "institution",
  //     //       institution.name,
  //     //       "not in",
  //     //       existingInstitutions,
  //     //       "- adding"
  //     //     );
  //     //     dispatch(
  //     //       updateStep("linkBank", {
  //     //         linkedAccounts: {
  //     //           ...(linkBank.linkedAccounts || {}),
  //     //           [institution.name]: [...(accounts || [])],
  //     //         },
  //     //         loading: false,
  //     //       })
  //     //     );
  //     //   }
  //     // } else {
  //     //   dispatch(
  //     //     updateStep("linkBank", {
  //     //       linkedAccounts: { [institution.name]: [...(accounts || [])] },
  //     //     })
  //     //   );
  //     // }
  //     // if (linkBank.institutions) {
  //     //   dispatch(
  //     //     updateStep("linkBank", {
  //     //       institutions: [...(linkBank.institutions || []), institution],
  //     //     })
  //     //   );
  //     // } else {
  //     //   dispatch(
  //     //     updateStep("linkBank", {
  //     //       institutions: [institution],
  //     //     })
  //     //   );
  //     // }
  //     // if (estimatedLimit !== undefined) {
  //     //   dispatch(updateUser({ estimatedLimit }));
  //     // }
  //   })
  //   .catch((error) => {
  //     console.log("linkAccount encountered an error:", error);
  //     dispatch(
  //       updateStep("linkBank", {
  //         loading: false,
  //       })
  //     );
  //     dispatch(
  //       setNetworkingError(
  //         "Your bank is taking longer than usual to communicate with our servers. Refresh the page in a few minutes, or try again."
  //       )
  //     );
  //   });
};

export const removeAccount = id => (dispatch, getState) => {
  console.log("removing account:", id);
  // const { jwt } = localStorage;
  // console.log("with jwt:", jwt);
  dispatch(
    updateStep("linkBank", {
      loading: true
    })
  );
  axios
    .post("/user/accounts/remove", { id })
    .then(response => {
      dispatch(
        updateStep("linkBank", {
          loading: false
        })
      );
      const { data, data: { removed, estimatedLimit, meetsBalanceThreshold } = {} } = response;
      if (data && removed) {
        const {
          register: {
            linkBank: { linkedAccounts },
            loginsRequired
          }
        } = getState();
        
        // {@rahmteen - meetsBalanceThreshold to pass to redux state for mock dashboard}
        dispatch(updateUser({ meetsBalanceThreshold }));

        const updatedLinkedAccounts = Object.keys(linkedAccounts).reduce(
          (a, i) => {
            const institution = i;
            const filtered = linkedAccounts[i].filter(a => a.id !== removed);
            if (filtered.length) {
              a[i] = filtered;
            }
            return a;
          },
          {}
        );
        dispatch(
          updateStep("linkBank", {
            linkedAccounts: updatedLinkedAccounts
          })
        );
        const updatedLoginsRequired = Object.keys(loginsRequired).reduce(
          (a, i) => {
            const filtered = loginsRequired[i].accounts.filter(
              a => a !== removed
            );
            if (!filtered.length) {
              return a;
            }
            return [...a, { ...loginsRequired[i], accounts: filtered }];
          },
          []
        );
        dispatch(setLoginsRequired(updatedLoginsRequired));

        if (estimatedLimit !== undefined) {
          dispatch(updateUser({ estimatedLimit }));
        }
      }
    })
    .catch(error => {
      console.log("error removing account:", error);
      dispatch(
        updateStep("linkBank", {
          loading: false
        })
      );
    });
};

export const removeFinicityAccount = id => (dispatch, getState) => {
  console.log("removing finicity account:", id);

  dispatch(
    updateStep("linkBank", {
      loading: true
    })
  );
  dispatch(
    updateStep("confirm", {
      loading: true
    })
  );
  axios
    .post("/api/v2/accounts/removeFinicityAccount", { id })
    .then(response => {
      dispatch(
        updateStep("linkBank", {
          loading: false
        })
      );
      dispatch(
        updateStep("confirm", {
          loading: false
        })
      );
      const { data, data: { removed, estimatedLimit, meetsBalanceThreshold } = {} } = response;
      if (data && removed) {
        const {
          register: {
            linkBank: { finicityAccounts },
            finicityLoginsRequired
          }
        } = getState();

        dispatch(updateUser({ meetsBalanceThreshold }));
        const updatedFinicityAccounts = finicityAccounts.filter(
          a => a.id !== removed
        );

        dispatch(
          updateStep("linkBank", {
            finicityAccounts: updatedFinicityAccounts
          })
        );

        const updatedFinicityLoginsRequired = Object.keys(finicityLoginsRequired).reduce(
          (a, i) => {
            const { accounts, ...rest } = finicityLoginsRequired[i]
            const filtered = accounts.filter(a => a.id !== removed);
            if (!filtered.length) return a;
            return {...a, [i]: { accounts: filtered, ...rest }};
          },
          {}
        );
        dispatch(setFinicityLoginsRequired(updatedFinicityLoginsRequired));
      }
    })
    .catch(error => {
      console.log("error removing finicity account:", error);
      dispatch(
        updateStep("linkBank", {
          loading: false
        })
      );
      dispatch(
        updateStep("confirm", {
          loading: false
        })
      );

      if (error && error.data) {
        dispatch(setNetworkingError(error.data));  
      }
    });
};

const updateUserIncome = income => ({
  type: types.UPDATE_USER_INCOME,
  income
});

const updateUserBalance = balance => ({
  type: types.UPDATE_USER_BALANCE,
  balance
});

// -----[ ALLOY ]----- //
export const verifyUser = () => (dispatch, getState) => {
  const { register: { user: { email, ssn } = {} } = {} } = getState();
  console.log("Perform KYC for user ", email);
  // const { blackbox, finished } =
  //   (window.IGLOO && (window.IGLOO.getBlackbox || (() => {}))()) ||
  //   JSON.parse(window.localStorage.getItem("io_bb")) ||
  //   {};
  // if (!finished) {
  //   console.log(
  //     "Error - iovation blackbox is in an unfinished state. Try reloading the page!"
  //   );
  //   dispatch(idValid(false));
  //   return;
  // }
  // if (!blackbox) {
  //   console.log(
  //     "Error - iovation blackbox data does not exist. There might be something wrong with iovation."
  //   );
  //   dispatch(idValid(false));
  //   return;
  // }
  dispatch(updateUser({ shouldEvaluate: false }));

  dispatch(updateUser({ evaluationComplete: true }));
  dispatch(
    updateUserDatabase(email, {
      applicationProgress: {
        lastCompletedStep: stepIndices.verifyId,
        verifyId: true,
        personalInformation: true,
        address: true, // SUS. Maybe only call if values exist?
        lastUpdated: new Date()
      }
    })
  );
  dispatch(
    updateStep("verifyId", {
      stepIsComplete: true
    })
  );
  dispatch(
    updateStep("processingId", {
      stepIsComplete: true
    })
  );
  dispatch(
    updateStep("personalInformation", {
      stepIsComplete: true
    })
  );
  dispatch(
    updateStep("address", {
      stepIsComplete: true
    })
  );
  dispatch(idValid(false));

  // This logic has been moved to the backend
  // axios
  //   .post("/api/v2/performKyc", { email, num: ssn })
  //   .then(response => {
  //     const data = response.data;
  //     const idComplete = () => {
  //       // Might wanna move this logic to backend
  //       dispatch(updateUser({ evaluationComplete: true }));
  //       dispatch(
  //         updateUserDatabase(email, {
  //           applicationProgress: {
  //             lastCompletedStep: stepIndices.verifyId,
  //             verifyId: true,
  //             personalInformation: true,
  //             address: true,
  //             lastUpdated: new Date()
  //           }
  //         })
  //       );
  //       dispatch(
  //         updateStep("verifyId", {
  //           stepIsComplete: true
  //         })
  //       );
  //       dispatch(
  //         updateStep("processingId", {
  //           stepIsComplete: true
  //         })
  //       );
  //       dispatch(
  //         updateStep("personalInformation", {
  //           stepIsComplete: true
  //         })
  //       );
  //       dispatch(
  //         updateStep("address", {
  //           stepIsComplete: true
  //         })
  //       );
  //     };
  //     if (data.success) {
  //       console.log("ID valid, woots!");
  //       idComplete();
  //       dispatch(idValid(true));
  //     } else if (!data.error) {
  //       console.log("ID not valid! Data returned:", data);
  //       idComplete();
  //       dispatch(idValid(false));
  //       track("ONBOARDING_IDENTITY_STEP_COMPLETE_FAILURE");
  //     } else {
  //       console.log("Server encountered error performing KYC:", data.error);
  //       dispatch(updateStep("processingId", { error: data.error }));
  //       dispatch(idValid(false));
  //     }
  //   })
  //   .catch(error => {
  //     console.log("Error performing KYC:", error);
  //     dispatch(updateStep("processingId", { error }));
  //     dispatch(idValid(false));
  //   });
};

// -----[ SYNAPSEFI ]----- //
// TODO: Should move fingerprint/token aquisition here

export const validateAddress = (payload, options = {}, callback) => (
  dispatch,
  getState
) => {
  const {
    address: {
      address_city: city,
      address_postal_code: zip,
      address_street: street1,
      address_street2: street2,
      address_subdivision: state
    } = {},
    options: payloadOptions = { notes: true, analysis: true }
  } = payload || {};

  const validatePayload = {
    address: { city, state, zip, street1, street2 },
    options: payloadOptions
  };
  console.log("Validate address with validatePayload ", validatePayload);
  axios
    .post("/validateAddress", validatePayload)
    .then(response => {
      const {
        data: { deliverability, address, analysis, error, invalid } = {}
      } = response || {};

      if (error) {
        callback({
          valid: false,
          error: `Error validating address${
            error.Description || error ? ` - ${error.Description || error}` : ""
          }`,
          response
        });
        return;
      }

      const {
        register: { user: { shippingAddress } = {} }
      } = getState();

      switch (deliverability) {
        case "deliverable":
        case "partial":
          console.log("Address is deliverable, even if partially");

          const {
            street1: nStreet1,
            street2: nStreet2,
            city: nCity,
            state: nState,
            zip: nZip
          } = address;

          const normalizedAddress = {
            street: `${nStreet1}${nStreet2 ? " " : ""}${nStreet2}`,
            city: nCity,
            state: nState,
            zip: nZip
          };

          const formattedNormalizedAddress = {
            address_street: normalizedAddress.street,
            address_city: normalizedAddress.city,
            address_subdivision: normalizedAddress.state,
            address_postal_code: normalizedAddress.zip,
            address_country_code: "US"
          };

          if (options.shipping) {
            console.log("options.shipping");
            dispatch(
              updateUser({
                shippingAddress: {
                  ...shippingAddress,
                  ...normalizedAddress,
                  normalizedAddress: formattedNormalizedAddress,
                  ...(address && { unitNumber: "" })
                }
              })
            );
          } else {
            console.log("no options.shipping");
            dispatch(
              updateUser({
                ...normalizedAddress,
                normalizedAddress: formattedNormalizedAddress,
                ...(address && { unitNumber: "" })
              })
            );
          }

          if (analysis && analysis.pobox) {
            callback({
              valid: false,
              normalized_address: formattedNormalizedAddress,
              error: "PO Boxes are not accepted at this time",
              poBoxError: true,
              response
            });
          } else {
            dispatch(addressValid());

            callback({
              valid: true,
              normalized_address: formattedNormalizedAddress,
              response
            });
          }

          break;
        case "missing":
          console.log("Address is undeliverable - missing secondary data");
          callback({
            valid: false,
            error:
              "Oops! An apartment, unit number, or townhouse number may be required",
            response
          });
          break;
        case "undeliverable":
          console.log("Address is undeliverable - invalid data");

          const tips = Object.keys(invalid || {}).map(
            k => `${k} is ${invalid[k]}`
          );
          callback({
            valid: false,
            error: `Not a deliverable address${
              tips.length ? ` - ${tips}` : ""
            }`,
            response
          });
          break;
        case "unknown":
          console.log("Address is undeliverable - unknown reasons");
          callback({
            valid: false,
            error: "Address could not be verified",
            response
          });
          break;
        default:
          console.log(
            "Address verification received an unknown deliverability status"
          );
          callback({
            valid: false,
            error: "Address validation error",
            response
          });
          break;
      }
    })
    .catch(error => {
      callback({
        valid: false,
        error: "Network error",
        networkError: true,
        response: error
      });
      console.log("Error validating address:", error);
    });
};

export const uploadGovtID = (side, payload) => dispatch => {
  // axios stuff - waiting for Jumio
  dispatch(govtIdUploaded(side, "success"));
  dispatch(govtIdUploaded(side, "failure"));
};

const govtIdUploaded = (side, status) => ({
  type: types.GOVT_ID_UPLOADED,
  side,
  status
});

const setRefreshToken = refreshToken => ({
  type: types.SET_REFRESH_TOKEN,
  refreshToken
});

//  -----[ VERIFICATION SMS ]----- //
export const verificationSmsSend = (phoneNumber, email) => dispatch => {
  axios
    .post("/verify/sms/send", {
      phone_number: phoneNumber,
      via: "sms",
      country_code: 1,
      code_length: 5,
      locale: "en",
      email
    })
    .then(response => {
      const { data } = response;
      if (data.codeSent || data.success) {
        console.log("Code was sent successfully");
        dispatch(verificationSmsSent(true));
        // TODO: Integrate updates, listening to FB, redux
        // axios
        //   .post("/updateUser", {
        //     userID: email, // get userID from sessionStorage or Redux
        //     payload: {
        //       phone: {
        //         number: phone_number,
        //         verified: false
        //       }
        //     }
        //   })
        //   .catch(error => {
        //     console.log(
        //       "Error updating user phone verification info: ",
        //       error
        //     );
        //   });
      } else {
        console.log("Code was NOT sent successfully");
        dispatch(verificationSmsSendError(data.message));
      }
    })
    .catch(error => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const { data } = error.response;
        console.log("Code send error: ", data);
        dispatch(verificationSmsSendError(error));
      } else if (error.request) {
        // The request was made but no response was received
        console.log("Code send error: ", error.request);
        dispatch(verificationSmsSendError(error));
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Code send error: ", error.message);
        dispatch(verificationSmsSendError(error));
      }
    });
};

const verificationSmsSendError = error => ({
  type: types.VERIFICATION_SMS_SEND_ERROR,
  error
});

export const verificationSmsCheck = ({
  phoneNumber,
  code,
  userId
}) => dispatch => {
  const sentData = {
    phone_number: phoneNumber,
    verification_code: code,
    country_code: 1
  };

  axios
    .post("/verify/sms/check", sentData)
    .then(response => {
      const { data } = response;
      if (data.success) {
        dispatch(verificationSmsValid(true));
        if (userId) {
          dispatch(updateUserDatabase(userId, { phoneNumberVerified: true }));
        }
      } else {
        if (data.errors) {
          dispatch(verificationSmsValid(false));
          dispatch(verificationSmsCheckError(data.message));
        }
      }
    })
    .catch(error => {
      if (error.response) {
        const { data } = error.response;
        if (data.error_code === "60023") {
          // This is the error code Twilio sends when the phone number has already been verified.
          dispatch(verificationSmsValid(true));
          dispatch(
            verificationSmsCheckError("Number has already been verified")
          );
        } else {
          dispatch(verificationSmsValid(false));
          dispatch(verificationSmsCheckError(data.message));
        }
      } else if (error.request) {
        console.log("Sms check error", error.request);
        dispatch(verificationSmsValid(false));
        dispatch(verificationSmsCheckError("Problem with network request"));
      } else {
        console.log("Sms check error", error.message);
        dispatch(verificationSmsValid(false));
        dispatch(verificationSmsCheckError(error.message));
      }
    });
};

export const setIdValid = valid => dispatch => {
  dispatch(idValid(valid));
};

export const setShowIdTips = show => dispatch => {
  dispatch(showIdTips(show));
};

const verificationSmsCheckError = error => ({
  type: types.VERIFICATION_SMS_CHECK_ERROR,
  error
});

// Make private after testing is over
export const verificationSmsSent = sent => ({
  type: types.VERIFICATION_SMS_SENT,
  sent
});

// Make private after testing is over
export const verificationSmsValid = valid => ({
  type: types.VERIFICATION_SMS_VALID,
  valid
});

const verificationSmsInvalid = () => ({
  type: types.VERIFICATION_SMS_INVALID
});

export const verificationSmsReset = () => ({
  type: types.VERIFICATION_SMS_RESET
});

//  -----[ ADDRESS, SSN, ID, VERFICATION ]----- //
const addressValid = () => ({
  type: types.ADDRESS_VALID
});

const addressInvalid = () => ({
  type: types.ADDRESS_INVALID
});

const ssnValid = () => ({
  type: types.SSN_VALID
});

const ssnInvalid = () => ({
  type: types.SSN_INVALID
});

export const setIdentityVerified = verified => ({
  type: types.SET_IDENTITY_VERIFIED,
  verified
});

export const setPhoneNumberVerified = verified => ({
  type: types.SET_PHONE_NUMBER_VERIFIED,
  verified
});

const idValid = valid => ({
  type: types.ID_VALID,
  valid
});

const setIdNeedsReview = idNeedsReview => ({
  type: types.SET_ID_NEEDS_REVIEW,
  idNeedsReview
});

export const setIdFront = imageData => ({
  type: types.SET_ID_FRONT,
  idFront: imageData
});

export const setIdBack = imageData => ({
  type: types.SET_ID_BACK,
  idBack: imageData
});

// -----[ STEPS ]----- //
export const updateStep = (stepName, payload) => ({
  type: types.UPDATE_STEP,
  stepName,
  payload
});

const setApplicationProgress = payload => ({
  type: types.SET_APPLICATION_PROGRESS,
  payload
});

// -----[ OTHER ]----- //
export const setFingerprint = fingerprint => ({
  type: types.SET_FINGERPRINT,
  fingerprint
});

export const setNetworkingError = error => ({
  type: types.SET_NETWORKING_ERROR,
  error
});

export const updateVerificationProgress = payload => ({
  type: types.UPDATE_VERIFICATION_PROGRESS,
  payload
});

const showIdTips = show => ({
  type: types.SHOW_ID_TIPS,
  show
});

export const setLoginsRequired = payload => ({
  type: types.SET_LOGINS_REQUIRED,
  payload
});

export const setFinicityLoginsRequired = payload => ({
  type: types.SET_FINICITY_LOGINS_REQUIRED,
  payload
});

export const setAggregatorType = payload => ({
  type: types.SET_AGGREGATOR_TYPE,
  payload
});

export const hydrateStateWithToken = ({
  email,
  jwt
}) => async dispatch => {
  console.log("Got email", email);
  identify(email);
  identifyHotjarUser({email})
  return await axios
    .post(
      "/users/getApplicationState",
      { email }
    )
    .then(response => {
      if (response.data.error) {
        console.log(
          "Application token invalid; should request user login. Error was:",
          response.data.error
        );
        if (response.data.expired) window.localStorage.removeItem("jwt");
        dispatch(setNetworkingError('There was an error, please try again.'));
        return false;
      } else {
        console.log("Got application state successfully");
      }

      const {
        email,
        firstName,
        lastName,
        ppAccepted,
        termsAccepted,
        phoneNumber,
        billingAddress: {
          city,
          state,
          street,
          zip,
          unitNumber,
          normalizedAddress
        } = {},
        shippingAddress,
        shippingAddress: { normalizedAddress: shippingNormalizedAddress } = {},
        dob,
        emailVerified,
        phoneNumberVerified,
        evaluationComplete,
        applicationProgress,
        applicationStatus,
        linkedAccounts,
        finicityAccounts,
        loginsRequired,
        finicityLoginsRequired,
        estimatedLimit,
        institutions,
        finicityInstitutions,
        w9Accepted,
        entityToken,
        aggregatorType,
        meetsBalanceThreshold,
        shouldShowHome
      } = response.data;

      dispatch(updateUser({ meetsBalanceThreshold, shouldShowHome }));
      dispatch(setApplicationProgress(applicationProgress));
      dispatch(setAggregatorType(aggregatorType));
      const depositoryAccountLinked =
        !!Object.keys(linkedAccounts).find(
          i =>
            !!linkedAccounts[i].find(a =>
              ["checking", "savings"].includes(a.subtype)
            )
        ) ||
        !!finicityAccounts.find(i => ["checking", "savings"].includes(i.type));
      const { linkBank, hasResumed } = applicationProgress || {};
      if (!linkBank && depositoryAccountLinked) {
        console.log(
          "User has refreshed the page before account linking finished. Fixing."
        );
        dispatch(updateStep("linkBank", { stepIsComplete: true, error: null }));
        dispatch(
          updateUserDatabase(
            email,
            {
              applicationProgress: {
                lastCompletedStep: stepIndices.linkBank,
                linkBank: true,
                lastUpdated: new Date()
              }
            },
            { headers: { Authentication: `Bearer ${jwt}` } }
          )
        );
      }
      if (applicationProgress && applicationProgress.documentUpload === true) {
        dispatch(updateStep("verifyIdDocs", { stepIsComplete: true }));
      }
      dispatch(
        updateUser({
          email,
          firstName,
          lastName,
          ppAccepted,
          termsAccepted,
          phoneNumber: phoneNumber || "",
          address:
            (normalizedAddress && normalizedAddress.address_street) || street, // Show normalized street if present
          city,
          state,
          zip,
          normalizedAddress,
          dob,
          unitNumber: normalizedAddress ? null : unitNumber, // Do not populate if we already have a normalized address
          w9Accepted,
          hasResumed,
          applicationStatus,
          estimatedLimit,
          shippingAddress: {
            ...shippingAddress,
            street:
              (shippingNormalizedAddress &&
                shippingNormalizedAddress.address_street) ||
              shippingAddress
                ? shippingAddress.street
                : null
          },
          evaluationComplete,
          entityToken,
          meetsBalanceThreshold
        })
      );
      dispatch(
        updateStep("linkBank", {
          linkedAccounts,
          finicityAccounts,
          institutions,
          finicityInstitutions
        })
      );
      if ((loginsRequired || {}).length)
        dispatch(setLoginsRequired(loginsRequired));
      if ((Object.keys(finicityLoginsRequired || {})).length)
        dispatch(setFinicityLoginsRequired(finicityLoginsRequired));
      // TODO: Ensure key names and step names align
      [
        "basicInfo",
        "confirm",
        "linkBank",
        "personalInformation",
        "student",
        "verifyId",
        "verifyPhone"
      ].map(step => {
        if (applicationProgress[step]) {
          dispatch(
            updateStep(step, {
              stepIsComplete: true
            })
          );
        }
      });
       
      dispatch(updateUser({ meetsBalanceThreshold }));
      if (jwt) {
        // Might not need to set this
        localStorage.setItem("jwt", jwt);
      }

      if (phoneNumberVerified) {
        console.log("phone number for ", email, " already verified");
        dispatch(setPhoneNumberVerified(phoneNumberVerified));
      } else {
        console.log("phone number for ", email, " not yet verified");
      }

      console.log("onboarding action returning with email", email);
      return {
        valid: true,
        applicationStatus,
        applicationProgress,
        emailVerified,
        email,
        loginsRequired,
        finicityLoginsRequired,
        meetsBalanceThreshold,
        shouldShowHome
      };
    })
    .catch(error => {
      console.log("hydrateStateWithToken caught error:", error);
      console.log(
        "Application token could not be verified; should request user login"
      );
      console.log("onboarding action error returning with email", email);
      return { valid: false, email };
    });
};

export const resolveEvent = payload => async dispatch => {
  const { user_id, plaid_item_id } = payload;
  return await axios
    .post("/accounts/relinked", { user_id, plaid_item_id })
    .then(res => {
      console.log("relink response:", res);
      const { decision } = res.data || {};
      if (decision === true) {
        dispatch(
          updateStep("decision", {
            decisionRan: true
          })
        );
      }
      return { decisionRan: decision };
    })
    .catch(err => {
      console.log("relink error:", err);
    });
};

export const fetchFinicityConnectURL = ({ userId, num }) => async dispatch => {
  dispatch(setNetworkingError(null));
  const success = await axios
    .post("/api/v2/accounts/getFinicityLink", { userId, num })
    .then(async response => {
      console.log("fetchFinicityConnectURL got data back:", response);
      const { success, error, message, link, customerId } = (response || {}).data || {};

      if (link) {
        dispatch(updateUser({ finicityConnectURL: link, finicityCustomerId: customerId }));
        return true;
      }

      if (!success || error) {
        console.log("Error fetching finicity connect URL:", error);
        dispatch(setNetworkingError("Something went wrong - please try again"));
      }
      return false;
    })
    .catch(error => {
      console.log("Error in fetchFinicityConnectURL:", error);
      dispatch(setNetworkingError("Something went wrong - please try again"));
      return false;
    });

  return success;
};

export const updateFinicityAccounts = ({ userId }) => async (
  dispatch,
  getState
) => {
  dispatch(setNetworkingError(null));
  dispatch(
    updateStep("linkBank", {
      loading: true
    })
  );
  const success = await axios
    .post("/api/v2/accounts/updateFinicityAccounts", { userId })
    .then(async response => {
      console.log("updateFinicityAccounts got data back:", response);
      const {
        accounts = [],
        unsupportedAccounts = [],
        removedAccounts = [],
        accountsLinked,
        institutions,
        estimatedLimit,
        meetsBalanceThreshold,
      } = (response || {}).data || {};

      dispatch(updateUser({ meetsBalanceThreshold }));
      dispatch(
        updateStep("linkBank", {
          loading: false
        })
      );

      console.log("finicity accounts", accounts, accountsLinked);

      dispatch(setNetworkingError(null));
      dispatch(updateStep("linkBank", { error: null }));

      const {
        register: {
          linkBank,
          user: { email }
        }
      } = getState();

      const depositoryAccountLinked = !!accounts.find(a =>
        ["checking", "savings"].includes(a.type)
      );

      console.log("depositoryAccountLinked -", depositoryAccountLinked);

      if ((unsupportedAccounts || []).length) {
        console.log(
          "There were unsupported finicity accounts returned.",
          `There ${
            accountsLinked ? "were" : `were not`
          } (${accountsLinked}) accounts linked. Displaying modal only if no accounts were linked.`
        );
        dispatch(
          updateStep("linkBank", {
            ...(!accountsLinked && { showUnsupportedAccountsModal: true }),
            unsupportedAccounts
          })
        );
      }

      if (accountsLinked && accountsLinked > 0) {
        if (depositoryAccountLinked) {
          dispatch(
            updateStep("linkBank", { stepIsComplete: true, error: null })
          );
          dispatch(
            updateUserDatabase(email, {
              applicationProgress: {
                ...(!linkBank.stepIsComplete && {lastCompletedStep: stepIndices.linkBank}),
                linkBank: true,
                lastUpdated: new Date()
              }
            })
          );
        }
      }

      let existingAccounts = linkBank.finicityAccounts || [];
      let finicityAccounts = [...existingAccounts, ...accounts];
      if ((removedAccounts || []).length) {
        finicityAccounts = finicityAccounts.filter(
          a => !removedAccounts.includes(a.id)
        );
      }
      dispatch(
        updateStep("linkBank", {
          finicityAccounts: [ ...finicityAccounts ],
          finicityInstitutions: { ...(linkBank.finicityInstitutions || []), ...(institutions || []) },
          loading: false
        })
      );
    })
    .catch(error => {
      console.log("Error in updateFinicityAccounts:", error);
      dispatch(
        updateStep("linkBank", {
          loading: false
        })
      );

      if (error && error.data) {
        dispatch(setNetworkingError(error.data));  
      } else {
        dispatch(setNetworkingError('There was an error updating your account, please try again.'));
      }      
      return false;
    });

  return success;
};
